// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-54b534ce&scoped=true!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/contacts/EditContactModal.vue
// module id = 439
// module chunks = 0